/**
 * @desc 根据计划ID查询年计划概览
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<Array<defs.PlanYearOverviewResponse>>> {
  return defHttp.post({
    url: '/web/plan/year/queryPlanOverview',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<Array<defs.PlanYearOverviewResponse>>> {
  return defHttp.post({
    url: '/mock/web/plan/year/queryPlanOverview',
    data,
  });
}
